import request from '../utils/request';

// 定制服务订单 API
export const customServiceOrderApi = {
  // 获取定制服务订单分页（POST，管理员）
  // data: { current, size, userId, requestId, orderNo, status, paymentStatus, shippingStatus, adminId, startTime, endTime }
  getCustomServiceOrderList: (data) => request.post('/custom-service-order/page', data),
  
  // 获取定制服务订单详情
  getCustomServiceOrderDetail: (id) => request.get(`/custom-service-order/${id}`),
  
  // 发货
  // id: 订单ID
  // data: { shippingStatus } (可选)
  shipOrder: (id, data) => request.post(`/custom-service-order/ship/${id}`, data || {}),
  
  // 更新定制服务订单状态
  updateCustomServiceOrderStatus: (id, data) => request.put(`/custom-service-order/${id}/status`, data),
  
  // 分配管理员
  assignCustomServiceOrder: (id, data) => request.put(`/custom-service-order/${id}/assign`, data),
  
  // 设置预计交付时间
  setDeliveryTime: (id, data) => request.put(`/custom-service-order/${id}/delivery-time`, data),
  
  // 确认完成订单
  completeCustomServiceOrder: (id) => request.put(`/custom-service-order/${id}/complete`),
  
  // 关闭订单
  cancelCustomServiceOrder: (id) => request.put(`/custom-service-order/${id}/cancel`),
  
  // 删除订单（软删除）
  deleteCustomServiceOrder: (id) => request.delete(`/custom-service-order/${id}`),
  
  // 导出订单
  exportCustomServiceOrders: (params) => request.get('/custom-service-order/export', { params, responseType: 'blob' })
}; 